(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popper } from '@material-ui/core';
import { COLOR, SHADOW, BORDER } from "../../constants/style.js";
var StyledContent = styled('div').withConfig({
  displayName: "Popover__StyledContent",
  componentId: "sc-1lbuidl-0"
})(["background-color:", ";color:", ";padding:20px;box-shadow:", ";border-radius:", ";& a,a:visited{color:#fff;text-decoration:none;}"], COLOR.dark, COLOR.white, SHADOW.soft, BORDER.radius.sm);

var FallbackAnchor = function FallbackAnchor(props) {
  return React.createElement("button", props, "Anchor");
};

var Popover = function Popover(props) {
  var children = props.children,
      anchor = props.anchor;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var Anchor = anchor ? React.cloneElement(anchor, {
    onClick: function onClick(e) {
      handleAnchorClick(e);
    }
  }) : FallbackAnchor;
  var anchorNode = useRef();
  var popoverNode = useRef();

  var handleClick = function handleClick(e) {
    if (popoverNode.current.contains(e.target)) {
      return;
    }

    close();
  };

  useEffect(function () {
    // console.log('Popover:mount');
    // document.addEventListener('mousedown', handleClick, false);
    // window.addEventListener('popstate', handleNavigation);
    history.onpushstate = function () {
      close();
    };

    return function () {// console.log('Popover:unmount');
      // document.removeEventListener('mousedown', handleClick, false);
      // window.removeEventListener('popstate', handleNavigation);
    };
  }, []);
  useEffect(function () {
    if (open) {
      document.addEventListener('mousedown', handleClick, false);
    } else {
      document.removeEventListener('mousedown', handleClick, false);
    }

    return function () {
      document.removeEventListener('mousedown', handleClick, false);
    };
  }, [open]);

  var handleAnchorClick = function handleAnchorClick(e) {
    setAnchorEl(e.currentTarget);
    setOpen(!open);
    e.preventDefault();
    e.stopPropagation();
  };

  var close = function close() {
    setOpen(false);
  };

  return React.createElement(Fragment, null, Anchor, React.createElement(Popper, {
    open: open,
    anchorEl: anchorEl,
    ref: popoverNode
  }, React.createElement(StyledContent, null, children ? children : React.createElement("div", null, "Popover content should be passed as children to the component."))));
}; // NOTE: Super dirty method for being able to close on navigation
// Should find a better way to do this


__signature__(Popover, "useState{[anchorEl, setAnchorEl](null)}\nuseState{[open, setOpen](false)}\nuseRef{anchorNode}\nuseRef{popoverNode}\nuseEffect{}\nuseEffect{}");

(function (history) {
  var pushState = history.pushState;

  history.pushState = function (state) {
    if (typeof history.onpushstate == 'function') {
      history.onpushstate({
        state: state
      });
    }

    return pushState.apply(history, arguments);
  };
})(window.history);

Popover.propTypes = {
  anchor: PropTypes.element
};
var _default = Popover;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledContent, "StyledContent", "/home/vsts/work/1/s/src/components/overlays/Popover.js");
  reactHotLoader.register(FallbackAnchor, "FallbackAnchor", "/home/vsts/work/1/s/src/components/overlays/Popover.js");
  reactHotLoader.register(Popover, "Popover", "/home/vsts/work/1/s/src/components/overlays/Popover.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/overlays/Popover.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();